import { render, staticRenderFns } from "./UserManageModal.vue?vue&type=template&id=542f647b&scoped=true"
import script from "./UserManageModal.vue?vue&type=script&lang=js"
export * from "./UserManageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f647b",
  null
  
)

export default component.exports